import { render } from "./InformacoesCliente.vue?vue&type=template&id=3aac2993"
import script from "./InformacoesCliente.vue?vue&type=script&lang=js"
export * from "./InformacoesCliente.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__